module.exports = __webpack_public_path__ + "img/backpack-complete-table-icon.d20f0b91.svg";